import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MtrwcServicePkg } from './mtrwcPkg.service';
import { jkLib, jkRestReturn } from 'jk-service';
import { Mtrwc } from '../_entity_mtr';
import { JkrangeComponent } from 'jk-advcom';

@Injectable({
  providedIn: 'root',
})
export class MtrwcService extends MtrwcServicePkg {
  constructor() {
    super();
  }
  override async doBeforePost(item: any, ret: jkRestReturn): Promise<boolean> {
    let bool = await super.doBeforePost(item, ret);
    await this.sumTotal();
    return bool;
  }
  async sumTotal(): Promise<boolean> {
    var mSQL;
    mSQL =
      "UPDATE MTRWB SET WB030=(CASE WHEN REC > 0 THEN 'Y' ELSE 'N' END)  FROM MTRWB LEFT JOIN  (SELECT COUNT(*) AS REC,WC001,WC002 FROM MTRWC GROUP BY WC001,WC002) AS A ON A.WC001=WB001 AND A.WC002=WB002 " +
      ' WHERE WB001=' +
      jkLib.quotedStr(this.entityType.billType) +
      ' AND WB002= ' +
      jkLib.quotedStr(this.entityType.billNo);
    var mRet = await this.orm.transactionOneSql(mSQL);
    if (!mRet.result) {
      return false;
    }
    return mRet.result;
  }
  override async newRecord(newItem: Mtrwc): Promise<Mtrwc> {
    await super.newRecord(newItem);

    newItem.WC001 = this.linkKeyObj.WC001; //this.entityType.billType;
    newItem.WC002 = this.linkKeyObj.WC002;
    newItem.WC004 = this.nowDate();
    /*this.setWC003().subscribe((ret) => {
      item.WC003 = ret.data;
      this.cdr.detectChanges();
    });*/
    newItem.WC003 = await this.setWC003(); // 回傳的單號
    // ▼ 加上這一行，主動告知 Angular 資料已變更
    if (this.cdr) {
      this.cdr.detectChanges();
    }
    return newItem;
  }
  async setWC003() {
    //return await this.orm.autoNoAsync('detail', 'MTRWC', this.keyFields.join(','), this.item.WC001 + ',' + this.item.WC002, '');// TODO:
    const ret = await this.orm.autoNo(
      'detail',
      'MTRWC',
      this.keyFields.join(','),
      this.item.WC001 + ',' + this.item.WC002,
      '',
      4,
    );
    return ret.data;
  }
}
